import type {z} from "zod";

import {UpdateMaterialFunctionBody} from "@project/sdk/engineering/zod";

export const updateMaterialFunctionFormSchema = UpdateMaterialFunctionBody;
export type UpdateMaterialFunctionFormPayload = z.output<typeof updateMaterialFunctionFormSchema>;

export const draftUpdateMaterialFunctionFormSchema = updateMaterialFunctionFormSchema.partial();
export type DraftUpdateMaterialFunctionFormPayload = z.output<
  typeof draftUpdateMaterialFunctionFormSchema
>;
